// Cancelar parte de um produto já enviado (dono, 26/09/2026: "passei dois refri
// e era só um"). A linha original fica com o que sobrou e uma cópia com o que
// saiu entra riscada NO FIM da lista — no fim de propósito: a cozinha marca
// pronto/entregue pela posição do produto no pedido, e inserir no meio mudaria
// a posição de todos os que vêm depois.
import { medidaDoItem } from "../../lib/unidadeVenda";

/** Quantas unidades a linha tem, quando dá pra cancelar em parte (inteiro ≥ 2,
 *  vendido por unidade). `null` = cancela a linha inteira, como antes.
 *  Quilo/litro pelo cadastro (`produtos`, 30/09/2026): o item gravado não
 *  guarda a unidade de venda — 2 kg de picanha cancela inteiro, não "1 de 2". */
export function unidadesCancelaveis(item, produtos) {
  if (!item || item.deleted || medidaDoItem(item, produtos)) return null;
  const q = Number(item.quantity ?? item.quantidade ?? 1);
  return Number.isInteger(q) && q >= 2 ? q : null;
}

const comQuantidade = (item, q) => ({
  ...item,
  quantity: q,
  ...(item.quantidade != null ? { quantidade: q } : {}),
});

/** `[linha que fica, cópia cancelada]` — `n` entre 1 e quantidade − 1. */
export function dividirParaCancelar(item, n, agoraIso, novoId, produtos) {
  const total = unidadesCancelaveis(item, produtos);
  if (!total || !(n >= 1 && n < total)) return null;
  const fica = comQuantidade(item, total - n);
  const cancelada = {
    ...comQuantidade(item, n),
    deleted: true,
    deleted_at: agoraIso,
    cartItemId: novoId,
    // Rodada do QR: a cópia continua no pedido da rodada, com id próprio
    ...(item._qid ? { _qid: `${item._qid}-c${novoId}` } : {}),
  };
  return [fica, cancelada];
}
